import type { Cart } from "@graphql/generated/types";

/**
 * A cart is Click & Collect if any line item carries a store supplyChannel.
 * Checking every line (not just the last) is required because the channel-bearing
 * line may not be the last one after cart edits (item removal, gift-wrap append).
 */
export const cartHasClickAndCollect = (cart?: Cart | null): boolean =>
    (cart?.lineItems ?? []).some((lineItem) => !!lineItem.supplyChannel);
